import { useEffect, useMemo, useState } from "react";
import { debounce } from "lodash";

const useDebounced = (value, delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  const updateDebouncedValue = useMemo(() => {
    return debounce(
      (nextValue) => {
        setDebouncedValue(nextValue);
      },
      delay,
      { leading: true },
    );
  }, [delay]);

  useEffect(() => {
    updateDebouncedValue(value);

    return () => {
      updateDebouncedValue.cancel();
    };
  }, [value, updateDebouncedValue]);

  return debouncedValue;
};

export { useDebounced };
